import { NUMBER_100, NUMBER_101, NUMBER_200, NUMBER_201, NUMBER_202 } from '~shared/constants';

export enum PaymentErrorCodes {
  GENERAL_VALIDATION_ERROR = NUMBER_100,
  COMPANY_VALIDATION_ERROR = NUMBER_101,
  SERVICE_PAYMENT_GENERAL_ERROR = NUMBER_200,
  SERVICE_PAYMENT_5XX_ERROR = NUMBER_201,
  SERVICE_PAYMENT_4XX_ERROR = NUMBER_202,
}
